/* Compare: localStorage selection, bar and table built from compare-row fetches. */
(function () {
  'use strict';
  /* Secties nemen dit bestand elk zelf op, dus staat het soms twee of drie keer
     op één pagina. De browser voert elke tag dan opnieuw uit, waardoor listeners
     op document dubbel hangen en één klik twee acties uitvoert. Deze poort laat
     alleen de eerste uitvoering door. */
  window.__hwsLoaded = window.__hwsLoaded || {};
  if (window.__hwsLoaded['component_compare']) return;
  window.__hwsLoaded['component_compare'] = true;

  var KEY = 'hws:compare';
  function read() {
    try { return JSON.parse(window.localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(list) {
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* ignore */ }
  }

  class HwsCompare extends HTMLElement {
    connectedCallback() {
      this.max = parseInt(this.dataset.max, 10) || 4;
      this.rows = this.readRows();
      this.bar = this.querySelector('[data-compare-bar]');
      this.itemsEl = this.querySelector('[data-compare-items]');
      this.countEl = this.querySelector('[data-compare-count]');
      this.tableEl = this.querySelector('[data-compare-table]');
      var self = this;
      document.addEventListener('change', function (event) {
        var toggle = event.target.closest('[data-compare-toggle]');
        if (!toggle) return;
        var handle = toggle.value;
        var list = read();
        var i = list.indexOf(handle);
        if (toggle.checked && i === -1) {
          if (list.length >= self.max) { toggle.checked = false; return; }
          list.push(handle);
        } else if (!toggle.checked && i !== -1) {
          list.splice(i, 1);
        }
        write(list);
        self.render();
      });
      this.addEventListener('click', function (event) {
        if (event.target.closest('[data-compare-clear]')) { write([]); self.render(); return; }
        var remove = event.target.closest('[data-compare-remove]');
        if (remove) {
          var list = read().filter(function (h) { return h !== remove.getAttribute('data-compare-remove'); });
          write(list); self.render();
        }
      });
      var modal = document.getElementById('CompareModal');
      if (modal) modal.addEventListener('hws:overlay:open', function () { self.renderTable(); });
      this.render();
    }

    readRows() {
      var s = this.querySelector('[data-compare-rows]');
      if (!s) return [];
      try { return JSON.parse(s.textContent); } catch (e) { return []; }
    }

    render() {
      var list = read();
      document.querySelectorAll('[data-compare-toggle]').forEach(function (input) {
        input.checked = list.indexOf(input.value) !== -1;
      });
      if (this.bar) this.bar.hidden = list.length === 0;
      if (this.countEl) this.countEl.textContent = list.length ? '(' + list.length + ')' : '';
      if (!this.itemsEl) return;
      this.itemsEl.innerHTML = '';
      var self = this;
      list.forEach(function (handle) {
        var li = document.createElement('li');
        li.className = 'compare__item';
        li.innerHTML =
          '<span>' + handle.replace(/-/g, ' ') + '</span>' +
          '<button type="button" data-compare-remove="' + handle + '" aria-label="' +
          ((window.hwsStrings || {}).compareRemove || 'Remove') + '">&times;</button>';
        self.itemsEl.appendChild(li);
      });
    }

    renderTable() {
      var list = read();
      if (!this.tableEl) return;
      if (list.length < 2) {
        this.tableEl.innerHTML = '<p class="compare__empty">' +
          ((window.hwsStrings || {}).compareEmpty || '') + '</p>';
        return;
      }
      var root = (window.hwsSettings || {}).routes.root || '/';
      var self = this;
      Promise.all(list.map(function (handle) {
        return fetch(root + 'products/' + handle + self.dataset.rowParam)
          .then(function (r) { return r.text(); })
          .then(function (t) { return new DOMParser().parseFromString(t, 'text/html').querySelector('[data-compare-row]'); })
          .catch(function () { return null; });
      })).then(function (nodes) {
        var found = nodes.filter(Boolean);
        if (!found.length) return;
        var table = document.createElement('table');
        table.className = 'compare__table';
        self.rows.forEach(function (row) {
          var tr = document.createElement('tr');
          var th = document.createElement('th');
          th.scope = 'row';
          th.textContent = row.label || '';
          tr.appendChild(th);
          found.forEach(function (node) {
            var td = document.createElement('td');
            var cell = node.querySelector('[data-compare-cell="' + row.key + '"]');
            td.innerHTML = cell ? cell.innerHTML : '—';
            tr.appendChild(td);
          });
          table.appendChild(tr);
        });
        self.tableEl.innerHTML = '';
        self.tableEl.appendChild(table);
      });
    }
  }
  if (!customElements.get('hws-compare')) customElements.define('hws-compare', HwsCompare);
})();
